import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DbcDocumentPdfModel } from '../dbc/models/dbcDocumentPdf.model';
import { AttachmentModel } from './models/attachment.model';
import { environment } from "environments/environment";
import { SharedService } from 'app/_services';

@Injectable({
    providedIn: 'root',
})

export class AttachmentService extends GenericService<AttachmentModel> {
    Alpha_Common_API_URL: string = environment.apiProtocol + environment.Services.CommonBaseURL;

    constructor(private http: HttpClient,private sharedService: SharedService) {
        super(http, '/DossierAttachment/')
    }

    private generateHeaders() {
        return {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          }),
        };
      }

    generateAttachment( templateName,dossierId,dossierHelpPlanId, organizationUnitId, language, generatedDocumentName, caseNumber): Observable<any>  {
        const body = {
                templateName,
                language,
                dossierId,
                caseNumber,
                dossierHelpPlanId,
                organizationUnitId,
                generatedDocumentName
        }
        return this._http.post(
            this.rootUrl+"/DossierAttachment/GenerateAttachment",body ,this.prepareHeader()).pipe(map(res => res as any)
        );
    }

    getAttachmentsByDossierId( dossierId): Observable<any>  {
        return this._http.get(
            this.rootUrl+"/DossierAttachment/GetByDossierId/"+dossierId, this.prepareHeader()).pipe(map(res => res as any)
        );
    }
    getEditableUrl(fileName): Observable<any>  {
        return this._http.get(
            this.rootUrl+"/DossierAttachment/editableLink/"+fileName, this.prepareHeader()).pipe(map(res => res as any)
        );
    }

    saveAttachment(dossierId, addAttachment,language,dossierHelpPlanId,templateName, organizationUnitId): Observable<any> {
        const query = this.sharedService.formatObjectToQueryString({dossierId,language,dossierHelpPlanId,templateName, organizationUnitId});
        const URI = `${this.rootUrl}/DossierAttachment/?${query}`;
        return this._http.post(URI,addAttachment,this.prepareHeader()).pipe(map(res => res as any))
    }

    updateAttachment(dossierAttachmentId,language,dossierHelpPlanId,templateName, organizationUnitId,attachmentToUpdate): Observable<any>{
        return this._http.put(
            this.rootUrl+"/DossierAttachment/"+dossierAttachmentId+"/"+language+"/"+dossierHelpPlanId+"/"+templateName+"/"+organizationUnitId,attachmentToUpdate  ,this.prepareHeader()).pipe(map(res => res as any)
        );
    }

    updateAttachmentTags(dossierAttachmentId,attachmentTagsToUpdate): Observable<any>{
        return this._http.put(
            this.rootUrl+"/DossierAttachment/UpdateAttachmentTags/"+dossierAttachmentId,attachmentTagsToUpdate  ,this.prepareHeader()).pipe(map(res => res as any)
        );
    }


    updateDragandDropAttachment(dossierAttachmentId,attachmentToUpdate): Observable<any>{
        return this._http.put(
            this.rootUrl+"/DossierAttachment/UpdateDragandDropAttachments/"+dossierAttachmentId,attachmentToUpdate  ,this.prepareHeader()).pipe(map(res => res as any)
        );
    }


    public prepareHeader(): Object {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
        return { headers: headers };
    }

    public getByDossierId (dossierId: string) : Observable<any[]> {
        return this._http.get(this.rootUrl +"/DossierAttachment/GetByDossierId/"+dossierId, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public softDeleteDossierAttachement (dossierAttachementId: string) {
        return this._http.put(this.rootUrl +"/DossierAttachment/SoftDeleteDossierAttachement/"+dossierAttachementId,this.generateHeaders());
    }

    public uploadFile (dossierId, attachmentList: DbcDocumentPdfModel[]) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/DossierAttachment/UploadAttachments/"+dossierId, attachmentList ,this.prepareHeader()).pipe(map(res => res as any[]))
    }
    public convertImgFileToPDF( base64Img: string) : Observable<any[]> {
        const body = {
            Base64Content: base64Img
        };
        return this._http.post(this.rootUrl +"/DossierAttachment/UploadBase64ImageAndGetPdfBase64", body ,this.prepareHeader()).pipe(map(res => res as any[]))
    }
    public convertDocxFileToPDF( base64Img: string) : Observable<any[]> {
        const body = {
            Base64Content: base64Img
        };
        return this._http.post(this.rootUrl +"/DossierAttachment/UploadBase64DocxAndGetPdfBase64", body ,this.prepareHeader()).pipe(map(res => res as any[]))
    }
    public getDocument(id : string){
        return this._http.get(this.Alpha_Common_API_URL + "/document/"+id,this.generateHeaders());
      }
    public uploadConvertedPDFFile (dossierId, attachmentBody) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/DossierAttachment/UploadConvertedPDFAttachments/"+dossierId, attachmentBody ,this.prepareHeader()).pipe(map(res => res as any[]))
    }
}